<template>
  <div class="user-set main-panel large">
    <h1 class="panel-title">销售人员二维码</h1>
    <div class="container">
      <!-- 左侧区域 -->
      <div class="left-box">
        <!-- 团队行：文字 + 右侧保存按钮 -->
        <div class="team-row">
          <span>• 团队</span>
          <el-button size="small" class="custom-btn" @click="save"
            >保存</el-button
          >
        </div>
        <div
          class="sales-item"
          v-for="(item, index) in lestlist"
          :key="item.id || index"
        >
          <span>• {{ item.content }}</span>
          <el-input
            v-model="item.name"
            placeholder=""
            style="width: 140px; margin: 0 8px"
          />
          <button
            v-if="index === lestlist.length - 1"
            style="background-color: #ffffff; border: none"
            @click="addOne"
          >
            <span style="font-size: 24px">+</span>
          </button>
        </div>
      </div>
      <!-- 右侧表格 -->
      <div class="right-box">
        <el-table
          :data="list"
          height="500px"
          border
          style="width: 100%"
          class="custom-table"
        >
          <el-table-column align="center" label="名称">
            <template #default="scope">
              {{ scope.row.name || "-" }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="二维码">
            <template #default="scope">
              <img
                v-if="scope.row.qrImg"
                :src="scope.row.qrImg"
                style="width: 80px; height: 80px"
              />
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="下载">
            <template #default="scope">
              <div class="options">
                <i
                  class="el-icon-download"
                  style="
                    font-size: 22px;
                    color: #61b88e;
                    margin-left: 12px;
                    cursor: pointer;
                  "
                  title="下载"
                  @click="up(scope.row)"
                ></i>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance } from "vue";
import { ElMessage } from "element-plus";
import QRCode from "qrcode";

const { proxy } = getCurrentInstance();
const $api = proxy.$api;

const list = ref([]);
const lestlist = ref([]);

// 根据id+bindCode生成二维码base64
const generateQrImg = async (row) => {
  if (!row.id || !row.bindCode) return "";
  console.log(process.env.VUE_APP_TITLE, "是什么标题");
  const httpurl =
    process.env.VUE_APP_TITLE == "样衣星球测试版"
      ? "https://yyyhao.58guoyin.com/"
      : "https://www.yyyhao.com/";
  try {
    // 手动拼接
    const qrUrl = `${httpurl}mp/product/colorcard/bindCode=${row.bindCode}&id=${row.id}`;
    console.log(qrUrl, "看一下参数");

    const dataUrl = await QRCode.toDataURL(qrUrl, {
      width: 160,
      margin: 1,
      color: {
        dark: "#000000",
        light: "#ffffff",
      },
    });
    return dataUrl;
  } catch (err) {
    console.error("二维码生成失败", err);
    return "";
  }
};

// 批量给列表每一项生成二维码
const renderAllQr = async () => {
  for (const item of list.value) {
    item.qrImg = await generateQrImg(item);
  }
};

// 获取列表
const getlist = async () => {
  const res = await $api.BasicData.getSalesPersonList({});
  console.log(res.data.code);
  if (res.data.code == 200) {
    list.value = res.data.data.list;
    lestlist.value = res.data.data.list.filter((item) => item.name !== "团队");
    await renderAllQr();
    console.log(list.value, "返回的列表是什么格式");
  } else {
    ElMessage.error("网络错误");
    list.value = [];
  }
};

// 合成：二维码图片 + 底部文字，返回新base64
const drawQrWithText = (imgSrc, text) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = imgSrc;
    img.onload = () => {
      // 二维码大小，文字区域高度
      const qrW = img.width;
      const qrH = img.height;
      const textH = 40;
      const canvas = document.createElement("canvas");
      canvas.width = qrW;
      canvas.height = qrH + textH;
      const ctx = canvas.getContext("2d");

      // 白底
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // 绘制二维码
      ctx.drawImage(img, 0, 0, qrW, qrH);

      // 绘制底部文字（居中）
      ctx.fillStyle = "#333333";
      ctx.font = "24px Microsoft YaHei, sans-serif";
      ctx.textAlign = "center";
      ctx.textBaseline = "top";
      ctx.fillText(text, canvas.width / 2, qrH + 6);

      resolve(canvas.toDataURL("image/png"));
    };
  });
};

// 下载二维码【改造后，图片底部带上名称】
const up = async (row) => {
  if (!row.qrImg) {
    ElMessage.warning("暂无二维码");
    return;
  }
  const nameText = `销售员:` + row.name || row.content || "二维码";
  // 合成带文字的图
  const finalImg = await drawQrWithText(row.qrImg, nameText);

  const a = document.createElement("a");
  a.href = finalImg;
  a.download = `${nameText}.png`;
  a.click();
};

// +新增销售项，content自动递增：销售1、销售2、销售3
// +新增销售项，调用后端新增接口
const addOne = async () => {
  const salesArr = list.value.filter((i) => i.content.startsWith("销售"));
  let maxNum = 0;
  salesArr.forEach((item) => {
    const num = Number(item.content.replace("销售", ""));
    if (!isNaN(num) && num > maxNum) maxNum = num;
  });
  const res = await $api.BasicData.addSalesPerson({
    name: "",
  });
  console.log(res.data, "看看返回了什么");
  if (res.data.code == "200") {
    ElMessage.success("新增成功");
    await getlist();
  } else {
    ElMessage.error("新增失败：" + (res.data.msg || "未知错误"));
  }
};

// 保存修改
const save = async () => {
  const sendata = {
    salesPersonList: list.value,
  };
  console.log("参数是否正确", sendata);
  try {
    const res = await $api.BasicData.updateSalesPerson(sendata);
    if (res.data.code == 200) {
      ElMessage.success("修改成功");
      getlist();
    } else {
      ElMessage.error("修改失败：" + (res.data.msg || "未知错误"));
    }
  } catch (error) {
    ElMessage.error("网络错误，修改失败");
  }
};

onMounted(async () => {
  await getlist();
});
</script>

<style lang="scss" scoped>
:deep(.custom-btn) {
  background-color: #ffae00 !important;
  border-color: #ffae00 !important;
  color: #333;
}
:deep(.el-dialog) {
  margin-top: 25vh !important;
}
:deep(.el-dialog--center .el-dialog__body) {
  height: 120px !important;
}
.main-panel.large {
  background-color: #fff;
  padding: 20px;
}
.panel-title {
  color: #333;
  text-align: center;
  margin-bottom: 24px;
}
.container {
  display: flex;
  gap: 24px;
}
.left-box {
  width: 30%;
  // 团队行样式：左右对齐
  .team-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    font-size: 16px;
  }
  .sales-item {
    display: flex;
    align-items: center;
    margin-bottom: 14px;
    .add-icon {
      font-size: 20px;
      color: #666;
      cursor: pointer;
    }
  }
}
.right-box {
  flex: 1;
}
:deep(.el-select .el-input__inner) {
  background-color: #fff;
}
:deep(.el-select .el-input__inner:focus) {
  background-color: #fff;
}
:deep(.custom-table) {
  background-color: #fff !important;
  .el-table__header-wrapper {
    background-color: #fff !important;
    .el-table__header {
      background-color: #fff !important;
      th {
        background-color: #fff !important;
      }
    }
  }
  .el-table__body-wrapper {
    background-color: #fff !important;
    .el-table__body {
      background-color: #fff !important;
      td {
        background-color: #fff !important;
      }
    }
  }
}
:deep(.el-dialog--center) {
  background-color: #fff !important;
}
.user-set {
  .top {
    width: 100%;
    height: 90px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    margin-bottom: 16px;

    .form {
      width: 65%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;

      .row {
        width: 112%;
        display: flex;

        & + .row {
          margin-top: 18px;
        }

        .item {
          display: flex;
          align-items: center;

          &.col-1 {
          }

          &.col-2 {
            flex: 2;
          }

          label {
            flex: 1;
          }

          .label {
            width: 78px;
            padding-right: 14px;
          }
        }
      }
    }

    .form-options {
      height: 100%;
      margin-left: 20px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      padding: 6px 0;
      box-sizing: border-box;

      .add {
        border-radius: 3px;
        margin-top: 32px;
      }
    }
  }

  .options {
    display: flex;
    justify-content: center;
    align-items: center;

    .update-icon {
      color: $font-color;
      cursor: pointer;
      font-size: 18px;
    }

    .del-icon {
      color: #f67575;
      cursor: pointer;
      margin-left: 10px;
      font-size: 18px;
    }
  }
}

.update-view {
  .item {
    display: flex;
    align-items: center;

    & + .item {
      margin-top: 20px;
    }

    .label {
      width: 58px;
      padding-right: 16px;
    }

    label {
      &:not(.el-checkbox) {
        flex: 1;
      }

      .cg-input {
        width: 100%;
        height: 34px;
        border: 0;
        background-color: transparent;
        border-bottom: 1px solid #ddd;
        padding: 4px 6px;
        box-sizing: border-box;
        font-size: 14px;
        color: #999;
      }
    }
  }

  .footer {
    text-align: center;
    margin-top: 20px;
  }
}
</style>
